import { render, staticRenderFns } from "./list-aretes-carrito.vue?vue&type=template&id=116e1010"
import script from "./list-aretes-carrito.vue?vue&type=script&lang=js"
export * from "./list-aretes-carrito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports